import { taxRateQuery, useDeleteTaxRateMutation } from "@common/api/tax-rates"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/archive",
)({
  component: ArchiveTaxRateDialog,
})

function ArchiveTaxRateDialog(): React.ReactElement {
  const { taxRateId } = Route.useParams()
  const { data: rate } = useSuspenseQuery(
    taxRateQuery({ tax_rate_id: taxRateId }),
  )
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const archiveMutation = useDeleteTaxRateMutation()

  const close = () =>
    navigate({
      to: "/settings/quoting/tax-rates/$taxRateId",
      params: { taxRateId },
      search: true,
    })

  const confirm = () =>
    archiveMutation.mutate(
      { tax_rate_id: taxRateId },
      {
        onSuccess: () => {
          showToast("Archived", `${rate.name} archived.`, "success")
          navigate({ to: "/settings/quoting/tax-rates", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${rate.name}?`}
      description="Archived tax rates keep their history and appear in the Archived tab."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={archiveMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
